<template>
  <div>
    <vs-row class="reports" vs-justify="space-between">
      <vs-col vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
        <!-- <vx-tooltip text="Seleziona ambito reportistica" position="left" :disabled="tp_bool"> -->
        <v-select
          class="search-select"
          :options="list_entities"
          v-model="filter_entity"
          name="filter_entity"
          :filterable="false"
          :clearable="false"
        />
        <!-- </vx-tooltip> -->
      </vs-col>
      <vs-col v-if="filter_entity.presets" vs-w="4" vs-lg="4" vs-sm="12" vs-xs="12">
        <v-select
          class="search-select"
          :options="filter_entity.presets"
          v-model="preset"
          name="preset"
          :filterable="false"
          :clearable="false"
        />
      </vs-col>
      <vs-col v-if="filter_entity.value" class="inline-flex" vs-w="2" vs-lg="2" vs-sm="12" vs-xs="12">
        <vx-tooltip text="Pyulisci selezione" position="left" class="resize_limits w-full-imp">
          <vs-button gradient size="large" class="w-full-imp" @click="clearSelection($event)" color="danger" type="line" icon-pack="feather" icon="icon-x" icon-after />
        </vx-tooltip>
      </vs-col>
      <vs-col v-if="filter_entity.value" class="inline-flex" vs-w="2" vs-lg="2" vs-sm="12" vs-xs="12">
        <vx-tooltip text="Scarica CSV" position="left" class="resize_limits w-full-imp">
          <vs-button gradient size="large" class="w-full-imp" @click="downloadCsv($event)" color="success" type="line" icon-pack="feather" icon="icon-download" icon-after />
        </vx-tooltip>
      </vs-col>
      <!-- <vs-col vs-w="2" vs-lg="2" vs-sm="2" vs-xs="12">
      </vs-col> -->
    </vs-row>
    <!-- <vs-row v-if="filter_entity.value" class="reports" vs-justify="space-between">
      <vs-col vs-w="5" vs-lg="5" vs-sm="12" vs-xs="12">
        <v-select
          class="search-select"
          :options="utenti"
          v-model="operatore"
          name="operatore"
          :filterable="false"
          :clearable="false"
        />
      </vs-col>
      <vs-col vs-w="5" vs-lg="5" vs-sm="12" vs-xs="12">
        <v-select
          class="search-select"
          :options="mesi"
          v-model="mese"
          name="mese"
          :filterable="false"
          :clearable="false"
        />
      </vs-col>
    </vs-row> -->
      <!-- <vs-col vs-w="5" vs-lg="5" vs-sm="12" vs-xs="12">
          <v-select class="search-select" :options="years" v-model="filter_year" name="filter_year" :filterable="false" :clearable="false" />
      </vs-col> -->
      <!-- <vs-col vs-w="2" vs-lg="2" vs-sm="2" vs-xs="12" vs-type="flex" vs-justify="center">
        <vx-tooltip text="Scarica CSV" position="left" class="resize_limits w-full-imp">
          <vs-button gradient size="large" disabled="true" class="w-full-imp" @click="getReport($event)" color="successo" type="line" icon-pack="feather" icon="icon-download" icon-after />
        </vx-tooltip>
      </vs-col> -->
    <!-- <vs-row class="reports" vs-justify="space-around">
    </vs-row> -->
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  data() {
    return {
      permessi: +localStorage.utente_permessi,
      utente_mail: localStorage.utente_mail,
      v_keyword: "",
      utenti: [],
      mesi: [{
        label:"Gennaio",
        value: 1
      },{
        label:"Febbraio",
        value: 2
      },{
        label: "Marzo",
        value: 3
      },{
        label: "Aprile",
        value: 4
      },{
        label: "Maggio",
        value: 5
      },{
        label: "Giugno",
        value: 6
      },{
        label: "Luglio",
        value: 7
      },{
        label: "Agosto",
        value: 8
      },{
        label: "Settembre",
        value: 9
      },{
        label: "Ottobre",
        value: 10
      },{
        label: "Novembre",
        value: 11
      },{
        label: "Dicembre",
        value: 12
      }],
      // tp_bool: false,
    // user infos
      tooltip: "ragione_sociale, operatore, servizio",
    // data request
      filter_entity: {label: 'Seleziona Ambito', value: null},
      preset: {label: 'Seleziona Preset', value: null},
      operatore: {label: 'Seleziona Operatore', id: null},
      mese: {label: 'Seleziona Mese', value: null},
      filter_year: {label: 'Seleziona anno', value: null},
      // countDown: 0
      list_entities: [
        {
          label: 'Preventivi',
          value: '/preventivo/trova_con_contratto',
          value_map: '/preventivo/map',
          rows: ['tariffa','servizio','stato'],
          cols: ['anno emissione'],
          aggr: 'Sum',
          icon: 'Edit3Icon',
          csv_fields: ["importo finale","sconto percentuale","voci","voci importo","tariffa","servizio","pacchetto","mese emissione","anno emissione","stato","creatore","responsabile","contatto","azienda","ufficio"],
          presets: [
              {
                label:'Vista annuale',
                value: '/preventivo/trova_con_contratto',
                rows: ['tariffa','servizio','stato'],
                cols: ['anno emissione'],
                aggr: 'Sum',
              },
              {
                label:'Paghe - A tariffa, Contratto 2024',
                value: '/preventivo/report_VI',
                rows: ['tariffa','stato','servizio','responsabile','ufficio','azienda'],
                cols: ['anno emissione','mese emissione'],
                aggr: 'Count',
              },
          ],
          //   {
          //     label:'Numero e importi per servizi',
          //     value: '/preventivo/report_I',
          //     rows: ['servizio'],
          //     cols: ['anno emissione'],
          //     aggr: 'Sum'
          //   },
          //   {
          //     label:'Dettagli per aziende per importo e numero',
          //     value: '/preventivo/report_II',
          //     rows: ['azienda'],
          //     cols: ['anno emissione'],
          //     aggr: 'Sum'
          //   },
          //   {
          //     label:'Numero e importi per Voci tariffa',
          //     value: '/preventivo/report_III',
          //     rows: ['ufficio','utente'],
          //     cols: ['anno emissione'],
          //     aggr: 'Sum'
          //   },
          //   {
          //     label:'Numero e importi per uffici e responsabile',
          //     value: '/preventivo/report_IV',
          //     rows: ['operatore','stato'],
          //     cols: ['anno emissione'],
          //     aggr: 'Sum'
          //   },
          //   {
          //     label:'Importi per trimestre, Numero e importi per responsabile utenti',
          //     value: '/preventivo/trova_con_contratto',
          //     rows: ['operatore','stato'],
          //     cols: ['anno emissione'],
          //     aggr: 'Sum'
          //   },
          //   {
          //     label:'Importi per trimestre confronto e percentuale anni precedenti',
          //     value: '/preventivo/trova_con_contratto',
          //     rows: ['operatore','stato'],
          //     cols: ['anno emissione'],
          //     aggr: 'Sum'
          //   },
          //   {
          //     label:'Dettagli',
          //     value: '/preventivo/trova_con_contratto',
          //     rows: ['operatore','stato'],
          //     cols: ['anno emissione'],
          //     aggr: 'Sum'
          //   },
        },
        {
          label: 'Contratti',
          value: '/contratto/trova_by_year',
          value_map: '/contratto/map',
          icon: 'ArchiveIcon',
          // rows: ['tariffa','stato','servizio'],
          // cols: ['anno emissione'],
          // aggr: 'Count',
          csv_fields: ["importo finale","sconto percentuale","voci","voci importo","tariffa","servizio","pacchetto","mese emissione","anno emissione","stato","creatore","responsabile","azienda","ufficio"],
          presets: [
            {
              label:'Vista annuale',
              value: '/contratto/trova_by_year',
              rows: ['tariffa','stato','servizio'],
              cols: ['anno emissione'],
              aggr: 'Count',
            },
            {
              label:'Dettagli',
              value: '/contratto/trova_by_year',
              rows: ['tariffa','stato','servizio','responsabile','ufficio','azienda'],
              cols: ['anno emissione','mese emissione'],
              aggr: 'Count',
            },
            {
              label:'Paghe - A tariffa, Firmati 2024',
              value: '/contratto/report_I',
              rows: ['tariffa','stato','servizio','responsabile','ufficio','azienda'],
              cols: ['anno emissione','mese emissione'],
              aggr: 'Count',
            },
          ],
        },
        // {
        //   label: 'Attività',
        //   value: '/board/attivita_lead/many',
        //   value_map: '/board/attivita_lead/map',
        //   rows: ['tipo'],
        //   cols: ['data_completamento'],
        //   icon: 'CalendarIcon'
        // },
        // {
        //   label: 'Leads',
        //   value: '/board/lead/many',
        //   value_map: '/board/lead/map',
        //   rows: ['azienda.tipo_azienda'],
        //   cols: ['stato.nome','canale'],
        //   icon: 'ActivityIcon'
        // },
        // {
        //   label: 'Tirocini',
        //   value: '/tirocinio/trova_by_year',
        //   value_map: '/tirocinio/map',
        //   rows: ['tutor.surname','tutor.name','stato'],
        //   cols: ['data_inserimento_anno','ufficio'],
        //   aggr: 'Count',
        //   icon: 'AwardIcon'
        // },
        {
          label: 'Rimborsi',
          value: '/rimborso/trova_by_year',
          value_map: '/rimborso/map',
          // presets: ['FirstReport','SecondReport'],
          rows: ['destinatario','stato','servizio'],
          cols: ['anno_emissione'],
          aggr: 'Sum',
          icon: 'PocketIcon',
          csv_fields: ["importo","importo pagato","destinatario","servizio","mese emissione","anno emissione","stato","creatore","operatore","contatto","azienda","ufficio"],
        },
        {
          label: 'Addebiti',
          value: '/addebito/trova_by_year',
          value_map: '/addebito/map',
          // presets: ['FirstReport','SecondReport'],
          rows: ['servizio','stato'],
          cols: ['anno_emissione'],
          aggr: 'Sum',
          icon: 'AlertOctagonIcon',
          csv_fields: ["importo finale","sconto percentuale","voci","voci importo","tariffa","servizio","mese emissione","anno emissione","stato","creatore","operatore","contatto","azienda","ufficio"],
        },
      ],
        // {
        //   label: 'Aziende',
        //   value: '/azienda/trova_by_document_year',
        //   value_map: '/azienda/map',
        //   presets: ['FirstReport','SecondReport'],
        //   rows: ['tariffa','stato.stato'],
        //   cols: ['servizio'],
        //   aggr: 'Sum',
        //   icon: 'GridIcon'
        // },
    }
  },
  props: {
    tipo: {
      type: Array,
      default: () => []
    },
    filter_list: {
      type: Array,
      required: false,
      default: () => []
    },
    dsbld: {
      type: Boolean,
      default: () => false
    },
    csv: {
      type: Boolean,
      required: false,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    vSelect,
  },
  computed: {
    checkDisabled() {
      if (this.loading) return true
    // possibility to trigger search also without v_keyword
      // if (!this.utente_permessi && this.filter_entity.value && this.filter_year.value) return false
      if (!this.utente_permessi && this.filter_entity.value) return false
      else return true
    },
    years() {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2019}, (value, index) => ({label: (2020+index).toString(), value: 2020+index}))
    }
  },
  methods: {
    getReport(ev) {
      let obj = {
        path: this.filter_entity.value,
        path_map: this.filter_entity.value_map,
        rows: this.filter_entity.rows,
        cols: this.filter_entity.cols,
        aggr: this.filter_entity.aggr,
        text: this.filter_entity.label,
        icon: this.filter_entity.icon,
        user: this.operatore.id,
        month: this.mese.value,
        // year: this.filter_year.value,
        // keyword: this.v_keyword
      }
      this.$emit('bulk-selection', obj)
      if (ev) ev.stopPropagation()
    },
    setPreset(ev) {
      let obj = {
        path: this.preset.value,
        path_map: this.filter_entity.value_map,
        rows: this.preset.rows,
        cols: this.preset.cols,
        aggr: this.preset.aggr,
        user: this.operatore.id,
        month: this.mese.value,
      }
      this.$emit('preset', obj)
      if (ev) ev.stopPropagation()
    },
    clearSelection(ev) {
      this.filter_entity = { label: 'Seleziona Ambito', value: null };
      this.preset = { label: 'Seleziona Preset', value: null };
      this.operatore = { label: 'Seleziona Operatore', id: null };
      this.mese = { label: 'Seleziona Mese', value: null };
      this.$emit('clear-selection')
      if (ev) ev.stopPropagation()
    },
    downloadCsv(ev) {
      let filename = 'Report ' + this.filter_entity.label + (this.preset && this.preset.value ? (' - ' + this.preset.label) : '')
      let obj = {
        filename: filename,
        fields: this.filter_entity.csv_fields
      }
      this.$emit('download-csv', obj)
      if (ev) ev.stopPropagation()
    },
    getUtenti() {
      axios.post(process.env.VUE_APP_BACKEND_API+'/utente/trova', {
        pag: 1,
        keyword: '',
        take: 1000 // should be removed
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true
      })
      .then(e => {
        this.utenti = e.data.res.map(e => {
          e['label'] = `${e['cognome']}`+' '+`${e['nome']}`
          return e
        })
        // Sort by 'cognome'
        this.utenti.sort((a, b) => {
          const cognomeA = a.cognome.toLowerCase();
          const cognomeB = b.cognome.toLowerCase();

          if (cognomeA < cognomeB) {
            return -1;
          }
          if (cognomeA > cognomeB) {
            return 1;
          }
          return 0;
        });
      }).catch(e => console.log(e))
    },
  },
  mounted() {
    this.getUtenti()
  },
  watch: {
    filter_entity() {
      // this.tp_bool = false
      this.preset = { label: 'Seleziona Preset', value: null };
      this.getReport()
    },
    preset() {
      this.setPreset()
    },
    operatore() {
      this.getReport()
    },
    mese() {
      this.getReport()
    },
  },
}
</script>

<style lang="css" scoped>
  /* .vs-row.reports .con-vs-tooltip.resize_limits {
    width: min-content;
  } */
  /* .reports .search-select {
    color: black !important;
  } */
  .reports {
    margin-top: 2em;
    margin-bottom: 2em;
  }
  .w-full-imp {
    width: 100% !important;
  }
</style>
